export default __webpack_public_path__ + "static/media/avatar.0134914e.png";